export default __webpack_public_path__ + "static/media/Alpha Hound Fang.80a870c3.jpg";